
Fundu.Pages.GuaranteeReview = (function($) {

  var _submitButton = false;
  var _acceptTerms = false;
  var _acceptFees = false;
  var _hasBeenInformed = false;

  var _guaranteeReviewForm = false;

  var _submitLock = false;

  var selectElements = function() {
    _submitButton = $("#guaranteeReviewSubmitButton");
    _acceptTerms = $("#acceptTerms");
    _acceptFees = $("#acceptFees");
    _hasBeenInformed = $("#hasBeenInformed");

    _guaranteeReviewForm = $("#guaranteeReviewForm");
  };

  var initializeSubmitButton = function() {
    setFormSubmitButtonDisabledState(true);

    _submitButton.on('click', function (e) {
      e.preventDefault();
      guarantee();
    });
  };

  $("#guaranteeReviewForm input[type='checkbox']").change(function () {
    var hasBeenInformed = _hasBeenInformed.attr("type") === "hidden" || _hasBeenInformed.is(":checked")
    var disableFormSubmitButton = !(_acceptTerms.is(":checked") && _acceptFees.is(":checked") && hasBeenInformed);

    setFormSubmitButtonDisabledState(disableFormSubmitButton);
  });

  function setFormSubmitButtonDisabledState(disabled) {
    _submitButton.attr("disabled", disabled);
  }

  var guarantee = function() {
    if(!_submitLock) {
      _submitLock = true;
      $.ajax({
        type: "POST",
        data: _guaranteeReviewForm.serialize(),
        url: _guaranteeReviewForm.attr('action')
      }).done(function (res) {
        if (res.redirect) {
          window.location.href = res.redirect;
        } else {
          console.error("Didn't receive redirect after a successful guarantee");
          Fundu.Helpers.Notify.error("global", "error.generic");
        }

        _submitLock = false;

      }).fail(function (res) {
        console.error("Guaranteeing failed with an unexpected error");
        Fundu.Helpers.Notify.error("global", "error.generic");

        _submitLock = false;
      });
    }
  };

  var initialize = function() {
    selectElements();
    initializeSubmitButton();

    return $.Deferred().resolve(true);
  };

  var finalize = function() {};

  return {
    init: initialize,
    finalize: finalize
  }

})(jQuery);
